'use client';

import { useEffect } from 'react';
import Script from 'next/script';

const InvocaScript = () => {
  const invocaId = '2389/4007993696';

  useEffect(() => {
    window.InvocaTagId = invocaId;
  }, []);

  return (
    <Script
      id="invoca-script"
      strategy="afterInteractive"
      src="https://solutions.invocacdn.com/js/invoca-latest.min.js"
      onError={() => console.error('Failed to load Invoca script')}
    />
  );
};

export default InvocaScript;
